{
  "selectAsField": "تحديد \"{value}\" كـ {fieldName}",
  "typeToSearchField": "اكتب للبحث عن {fieldName}",
  "licenseFieldLabel": "تحديد لوحة الترخيص (مثال: 215BG2)",
  "licenseFieldName": "لوحة الترخيص",
  "licensePlaceholder": "البحث برقم اللوحة",
  "dotFieldLabel": "تحديد رقم DOT",
  "dotFieldName": "رقم DOT",
  "dotPlaceholder": "البحث برقم DOT",
  "chooseOneOption": "اختر أحد الخيارات أدناه"
}
